import type { ReactNode } from "react";

import { AuthProvider, useAuth } from "./auth/AuthContext.js";
import { useLiveConnection } from "./lib/live.js";
import { Login } from "./pages/Login.js";
import { Mail } from "./pages/Mail.js";

/**
 * Twee toestanden, dus geen router: ingelogd of niet. Een adresbalk met paden
 * zou bij deze app alleen maar deelbare URL's naar andermans mailbox suggereren.
 */
function Routes(): ReactNode {
  const { status, active, accounts } = useAuth();

  // Eén live-verbinding voor alle mailboxen, hier en niet in Mail: die blijft
  // dan staan als de gebruiker van mailbox wisselt.
  useLiveConnection(status === "authenticated", accounts.map((a) => a.id).join(","));

  // Zolang we het sessiecookie natrekken tonen we niets: een loginformulier dat
  // meteen weer verdwijnt leert de gebruiker zijn wachtwoord te snel intikken.
  if (status === "checking") return <div className="boot" aria-busy="true" />;
  if (status !== "authenticated" || active === null) return <Login />;

  // Per mailbox een eigen Mail: wisselen begint met een schone lei, zodat er
  // nooit een map of bericht van de ene mailbox onder de naam van de andere
  // blijft staan.
  return <Mail key={active.id} account={active} />;
}

export default function App(): ReactNode {
  return (
    <AuthProvider>
      <Routes />
    </AuthProvider>
  );
}
